import { render } from "./LayoutWithoutNav.vue?vue&type=template&id=55b570aa&scoped=true&ts=true"
import script from "./LayoutWithoutNav.vue?vue&type=script&lang=ts"
export * from "./LayoutWithoutNav.vue?vue&type=script&lang=ts"

import "./LayoutWithoutNav.vue?vue&type=style&index=0&id=55b570aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b570aa"]])

export default __exports__